import { FormattedMessage } from 'react-intl';

import { OrderActionName } from './order-workflow';

export { OrderActionName } from './order-workflow';

export class OrderAction {
    static readonly ORDER_CHANGE_STATE = new OrderAction(
        OrderActionName.ORDER_CHANGE_STATE,
        (
            <FormattedMessage
                id='OrderAction.order_change_state'
                description='The displayed value for the OrderAction order_change_state'
                defaultMessage='Change order state'
            />
        )
    );
    static readonly ORDER_NOTIFY_CC = new OrderAction(
        OrderActionName.ORDER_NOTIFY_CC,
        (
            <FormattedMessage
                id='OrderAction.order_notify_cc'
                description='The displayed value for the OrderAction order_notify_cc'
                defaultMessage='Notify CC'
            />
        )
    );
    static readonly ORDER_NOTIFY_ORDERER = new OrderAction(
        OrderActionName.ORDER_NOTIFY_ORDERER,
        (
            <FormattedMessage
                id='OrderAction.order_notify_orderer'
                description='The displayed value for the OrderAction order_notify_orderer'
                defaultMessage='Notify orderer'
            />
        )
    );
    static readonly ORDER_UPDATE_BUDGET_USE = new OrderAction(
        OrderActionName.ORDER_UPDATE_BUDGET_USE,
        (
            <FormattedMessage
                id='OrderAction.order_update_budget_use'
                description='The displayed value for the OrderAction order_update_budget_use'
                defaultMessage='Update budget use'
            />
        )
    );
    static readonly ORDER_REMOVE_BUDGET_USE = new OrderAction(
        OrderActionName.ORDER_REMOVE_BUDGET_USE,
        (
            <FormattedMessage
                id='OrderAction.order_remove_budget_use'
                description='The displayed value for the OrderAction order_remove_budget_use'
                defaultMessage='Remove budget use'
            />
        )
    );

    static readonly ALL = [
        OrderAction.ORDER_CHANGE_STATE,
        OrderAction.ORDER_NOTIFY_CC,
        OrderAction.ORDER_NOTIFY_ORDERER,
        OrderAction.ORDER_UPDATE_BUDGET_USE,
        OrderAction.ORDER_REMOVE_BUDGET_USE
    ];

    constructor(
        public readonly value: OrderActionName,
        public readonly displayName: React.ReactNode
    ) {}

    static getByValue(action: string): OrderAction | undefined {
        return this.ALL.find((item) => item.value === action);
    }
}
